// import Speech from 'speak-tts'
import { langs } from '@/services/atlastories'
import { gpsWatchPosition, gpsClearWatch, gpsOptions } from '@/services/geolocation'

// accept an object, all props are a setting
export const setSetting = ({ commit }, object) => commit('setSetting', object)

// check data connection
export const setOnline = ({ commit }) => {
  commit('setOnline', navigator.onLine)
}

// stop geolocation service
export const geoStop = ({ commit }) => {
  gpsClearWatch()
  commit('setSetting', { follow: false })
}

// start geolocation service
export const geoStart = ({ commit, state }, opts) => {
  const options = opts || gpsOptions(state.settings.gps)
  return new Promise((resolve, reject) => {
    commit('setGeoLoading', true)
    commit('setSetting', { follow: true })
    gpsWatchPosition(pos => {
      commit('setGeoLocation', pos)
      commit('setGeoErr', null)
      commit('setGeoLoading', false)
      commit('setGeoActive', true)
      resolve(pos)
    }, err => {
      if (err.code === 1) commit('setGeoErr', 'Please activate/allow access to your Geolocation')
      else commit('setGeoErr', err.message)
      commit('setGeoLoading', false)
      commit('setSetting', { follow: false })
      commit('setGeoActive', false)
      reject(err)
    }, options)
  })
}

// start geolocation service
export const geoReStart = ({ commit, state }, opts) => {
  const options = opts || gpsOptions(state.settings.gps)
  return new Promise((resolve, reject) => {
    commit('setGeoLoading', true)
    gpsWatchPosition(pos => {
      commit('setGeoLocation', pos)
      commit('setGeoErr', null)
      commit('setGeoLoading', false)
      commit('setGeoActive', true)
      resolve(pos)
    }, err => {
      if (err.code === 1) commit('setGeoErr', 'Please activate/allow access to your Geolocation')
      else commit('setGeoErr', err.message)
      commit('setGeoLoading', false)
      commit('setGeoActive', false)
      reject(err)
    }, options)
  })
}

export const setFlyTo = ({ commit }, aLatLon) => {
  commit('setFlyTo', aLatLon)
}

export const getVoices = ({ commit }, payload) => {
  const speechInstance = payload.speechInstance
  const voices = payload.availableVoices
  return new Promise((resolve, reject) => {
    langs().then(res => {
      const langages = res.data
      console.log('getVoices -> langages', langages)
      if (speechInstance.hasBrowserSupport()) {
        const languageCodes = langages.map(l => l.code)
        const synthVoices = voices.filter(v => v.localService && languageCodes.includes(v.lang.split('-')[0]))
        // filter to have only one voice for each language
        let langs = []
        for (let lang of langages) {
          const voice = synthVoices.find(v => v.lang.split('-')[0] === lang.code)
          if (voice) {
            const langWithVoice = Object.assign({}, lang, { voice: voice.voiceURI })
            langs.push(langWithVoice)
          }
        }
        commit('setLangs', langs)
      } else {
        const languageCodes = langages.map(l => l.code)
        const synthVoices = voices.filter(v => languageCodes.includes(v.split('-')[0]))
        let langs = []
        for (let lang of langages) {
          console.log('getVoices -> lang', lang)
          const _voice = synthVoices.find(v => v.split('-')[0] === lang.code)
          if (_voice) {
            const langWithVoice = Object.assign({}, lang, { voice: _voice })
            langs.push(langWithVoice)
          }
        }
        commit('setLangs', langs)
      }
      resolve(langages)
    })
  })
}

export const setLang = ({ commit }, string) => commit('setLang', string)

export const setMarkers = ({ commit }, array) => commit('setMarkers', array)
export const setMarkersLoading = ({ commit }, bool) => commit('setMarkersLoading', bool)
export const setSwiper = ({ commit }, array) => commit('setSwiper', array)
export const setHighlight = ({ commit }, marker) => commit('setHighlight', marker)

export const setRouteMarker = ({ commit }, object) => commit('setRouteMarker', object)
export const setRouteMode = ({ commit }, string) => commit('setRouteMode', string)
export const setRoutePath = ({ commit }, object) => commit('setRoutePath', object)
// export const setRoutePolyline = ({ commit }, array) => commit('setRoutePolyline', array)
// export const setRouteInstructions = ({ commit }, array) => commit('setRouteInstructions', array)
